import { React, Component } from 'react';

import style from './style';
import screenWidth from '../utils/constant';

class LetsTalk extends Component {
	constructor(props) {
		super(props);
	}

	handleClick() {
		let link = window.location.origin + '/#/getintouch';
		window.location.href = link;
	}

	render() {
		let { shouldDisplay } = this.props;
		return (
			<div style={shouldDisplay ? null : 'display: none'}>
				<div class={style.LetsTalkFooter}>
					<div class={style.overlay} />
					<div class={style.gdpConnect}>
						<div class={style.gdpText}>
							<p class={style.text}>TALK TO US</p>
							<p class={style.desc}>
								Get your message in front of your audience. <br /> Find out how
							</p>
						</div>
						<div
							class={style.rectangle}
							onClick={() => {
								this.handleClick();
							}}
						>
							<a>LET'S TALK</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

LetsTalk.defaultProps = {
	shouldDisplay : true
};
export default LetsTalk;



// WEBPACK FOOTER //
// ./components/LetsTalk/index.js